import { component } from "picoapp";

export default component((node) => {
  const all = document.querySelectorAll(
    ".additional-product-information_container"
  );

  node.addEventListener("click", () => {
    if (!node.hasAttribute("open")) {
      all.forEach((detail) => detail.removeAttribute("open"));
    }
  });
});
